// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-knowledge-center-tsx": () => import("./../../../src/pages/knowledge-center.tsx" /* webpackChunkName: "component---src-pages-knowledge-center-tsx" */),
  "component---src-templates-knowledge-post-tsx": () => import("./../../../src/templates/knowledgePost.tsx" /* webpackChunkName: "component---src-templates-knowledge-post-tsx" */)
}

